<script setup>
import moment from "moment";
import DatepickerInput from "./datepicker/DatepickerInput.vue";
import DatePickerModal from "@/components/global-themed/inputs/datepicker/DatePickerModal.vue";
import {computed, ref} from "vue";

const props = defineProps({
  range: {
    type: Array,
    required: true,
  },
  compareRange: {
    type: Array,
    required: false,
    default: () => [],
  },
  variant: {
    type: String,
    required: false,
    default: 'primary',
    validator: (value,) => ['primary', 'secondary'].includes(value),
  }
})

const toggleShowPicker = () => {
  showPicker.value = true;
}

defineExpose({
  toggleShowPicker,
})

const emit = defineEmits(['change']);

const showPicker = ref(false)

const propsFromDate = computed(() => props.range[0] ?? undefined);
const propsToDate = computed(() => props.range[1] ?? undefined);

</script>

<template>
  <div class="tw-relative">
    <div class="tw-flex tw-gap-6">
      <div>
        <label
          for="from"
          class="tw-text-grey tw-text-xs tw-mb-4"
        >From</label>
        <DatepickerInput
          id="from"
          :value="propsFromDate ? moment(propsFromDate).format('DD/MM/YYYY') : ''"
          :class="{
            'tw-border-primary' : showPicker,
          }"
          @click="showPicker = true"
        />
      </div>
      <div>
        <label
          for="to"
          class="tw-text-grey tw-text-xs tw-mb-4"
        >To</label>
        <DatepickerInput
          id="to"
          :value="propsToDate ? moment(propsToDate).format('DD/MM/YYYY') : ''"
          :class="{
            'tw-border-primary' : showPicker,
          }"
          @click="showPicker = true"
        />
      </div>
    </div>

    <DatePickerModal
      v-if="showPicker"
      :variant="variant"
      :range="range"
      :compare-range="compareRange"
      @change="(newRange) => emit('change', newRange)"
      @close="showPicker = false"
    />
  </div>
</template>
